import React, { useEffect, useState } from 'react';
import { ThemeFontStyleTypeEnum } from '@inter-ikea-kompis/enums/lib';
import { isRoomConfigurationActive } from 'ducks/layout';
import RtlStyles from 'i18n/rtl';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import SlideOutMenu from 'components/SlideOutMenu/SlideOutMenu';
import styled from 'styled-components';
import Title from 'ui/Typography/Title';
import KvadratRoomConfigurationMenu from './KvadratRoomConfigurationMenu';
import { useCore } from 'contexts/core';
import { AppRoutes } from 'routes';
import { useLocation } from 'react-router-dom';

const Menu = styled.div`
  width: ${({ theme }) => theme.layout.sidebarWidth};
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 20;
  height: 100%;
  padding: 0 ${({ theme }) => theme.space.xxl};
  overflow-x: auto;
`;

const Header = styled.div`
  display: flex;
  padding: ${({ theme }) => theme.space.mdl} 0;
  position: sticky;
  top: 0;
  background-color: ${({ theme }) => theme.colors.white};
  z-index: 1;
`;

const RoomConfigurationMenu = () => {
  const roomConfigurationActive = useSelector(isRoomConfigurationActive);
  const { formatMessage } = useIntl();
  const coreApi = useCore();
  const location = useLocation();
  const [currentlyOnPlannerPage, setCurrentlyOnPlannerPage] = useState(
    location.pathname === AppRoutes.PLANNER
  );

  useEffect(() => {
    if (location.pathname === AppRoutes.PLANNER) {
      setCurrentlyOnPlannerPage(true);
    } else {
      setCurrentlyOnPlannerPage(false);
    }
  }, [currentlyOnPlannerPage, location.pathname]);

  useEffect(() => {
    if (!currentlyOnPlannerPage && coreApi.kvadratRoom?.kvadrat?.isOpen()) {
      coreApi.kvadratRoom?.kvadrat.close().then(() => {
        coreApi.camera.restoreCamera();
      });
    }
  }, [
    coreApi,
    coreApi.camera,
    coreApi.kvadratRoom,
    currentlyOnPlannerPage,
    roomConfigurationActive
  ]);

  return (
    <SlideOutMenu trigger={roomConfigurationActive}>
      <RtlStyles>
        <Menu>
          <Header>
            <Title
              display="flex"
              alignItems="center"
              type={ThemeFontStyleTypeEnum.headingMedium}
              mx={0}
            >
              {formatMessage({ id: 'storageone.roomConfigurationMenuTitle' })}
            </Title>
          </Header>
          <KvadratRoomConfigurationMenu />
        </Menu>
      </RtlStyles>
    </SlideOutMenu>
  );
};

export default RoomConfigurationMenu;
